import { render, staticRenderFns } from "./OrganizationReports.vue?vue&type=template&id=5fcb7a4c&"
import script from "./OrganizationReports.vue?vue&type=script&lang=js&"
export * from "./OrganizationReports.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports